module.exports = __webpack_public_path__ + "static/img/6areaA_3.9a1b958.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/6areaA_3.png
// module id = 967
// module chunks = 1